import { render, staticRenderFns } from "./MyQuotationCroCreate.vue?vue&type=template&id=06bd9bde&scoped=true&"
import script from "./MyQuotationCroCreate.vue?vue&type=script&lang=js&"
export * from "./MyQuotationCroCreate.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotationCroCreate.vue?vue&type=style&index=0&id=06bd9bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd9bde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bd9bde')) {
      api.createRecord('06bd9bde', component.options)
    } else {
      api.reload('06bd9bde', component.options)
    }
    module.hot.accept("./MyQuotationCroCreate.vue?vue&type=template&id=06bd9bde&scoped=true&", function () {
      api.rerender('06bd9bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationCroCreate.vue"
export default component.exports